import "./import/modules";
import "./import/components";

import { Fancybox } from "@fancyapps/ui";
import Snackbar from "awesome-snackbar";
import ClipboardJS from "clipboard";
import tippy from "tippy.js";

function initStickyButton() {
    const target = document.querySelector(".sticky");

    if (!target) {
        return;
    }

    if (!("IntersectionObserver" in window)) {
        target.style.opacity = "1";
        return;
    }

    let observer;
    let resizeFrame;

    const observeTarget = () => {
        observer?.disconnect();

        const remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const rootMargin = `0px 0px -${4.5 * remSize}px 0px`;

        observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                target.style.opacity = entry.isIntersecting ? "1" : "0";
            });
        }, {
            rootMargin,
            threshold: 0.1,
        });

        observer.observe(target);
    };

    const updateLayout = () => {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
        observeTarget();
    };

    const handleResize = () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(updateLayout);
    };

    updateLayout();
    window.addEventListener("resize", handleResize, { passive: true });
}

function initFancybox() {
    if (document.querySelector("[data-fancybox]")) {
        Fancybox.bind("[data-fancybox]", {
            Hash: false,
            Thumbs: false,
        });
    }
}

function initClipboard() {
    if (!document.querySelector(".clipboard")) {
        return;
    }

    const clipboard = new ClipboardJS(".clipboard", {
        text: trigger => {
            const type = trigger.dataset.clipboardType || "";
            let text = trigger.dataset.clipboardText || "";

            if (type === "unicode") {
                text = JSON.parse(`"${text}"`);
            }

            return text;
        },
    });

    clipboard.on("success", event => {
        new Snackbar(event.trigger.dataset.msg || "Copied to clipboard", {
            actionText: "Ok",
            position: "bottom-right",
        });

        event.clearSelection();
    });
}

function initTooltips() {
    if (document.querySelector("[data-tippy-content]")) {
        tippy("[data-tippy-content]", {
            interactive: true,
            arrow: false,
        });
    }
}

function initInternalPageNavigation() {
    const title = document.title.split(" | ")[1];
    const pageTitle = document.querySelector(".page-title");

    if (pageTitle && title) {
        pageTitle.textContent = title;
    }

    const currentPage = window.location.pathname.split("/").pop() || "index.html";

    document.querySelectorAll(".nav__link").forEach(link => {
        if (link.getAttribute("href") === currentPage) {
            link.classList.add("active");
            link.setAttribute("aria-current", "page");
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    initStickyButton();
    initFancybox();
    initClipboard();
    initTooltips();
    initInternalPageNavigation();
});
